import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ApiServiceService } from 'src/app/services/api-service.service';
import { DownloadFileServiceService } from 'src/app/services/download-file-service.service';
import { StorageServiceService } from 'src/app/services/storage-service.service';

@Component({
  selector: 'app-view-parent',
  templateUrl: './view-parent.component.html',
  styleUrls: ['./view-parent.component.scss']
})
export class ViewParentComponent implements OnInit {
  parent_id: any
  parent_data: any
  selectGrade: any = '';
  grades: any = [];
  selectSubjects: any = [];
  subjects: any = [];
  firstName: any = '';
  lastName: any = '';
  email: any = '';
  phone: any = '';
  parentName: any = '';
  address: any = '';
  city: any = '';
  state: any = '';
  country: any = '';
  zipCode: String = '';
  school: any = '';
  year: any = '';
  subjectData: any = []
  constructor(private router: Router, private toastr: ToastrService,
    private apiService: ApiServiceService,
    private loader: NgxUiLoaderService, private storageService: StorageServiceService,
    private route: ActivatedRoute,
    private download: DownloadFileServiceService) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.parent_id = params.id
    });
    if (this.parent_id) {
      this.getData()
      this.getGrades()
      this.getSubjects()
    }
  }
  update() {
    // debugger
    // console.log(this.selectSubjects)
    // return
    this.loader.start()
    let data = {
      user_id: this.parent_id,
      first_name: this.firstName,
      last_name: this.lastName,
      // email: this.email,
      parent_name: this.parentName,
      school_name: this.school,
      school_year: this.year,
      phone: this.phone,
      grade_level: [{ grade_id: this.selectGrade._id }],
      // subject: 1,
      address: this.address,
      state: this.state,
      country: this.country,
      city: this.city,
      zipCode: this.zipCode.toString()
    }
    if (this.subjectData.length > 0) {
      data['subject'] = this.subjectData
    }
    this.apiService
      .postMethod('/user/edit_profile/', data)
      .subscribe((response: any) => {
        if (response.code == 200) {
          this.loader.stop()
          // this.student_data = response.data
          console.log(response);
          this.toastr.success(response.message);

          this.router.navigate(['/parent']);

        } else {
          this.loader.stop();
          this.toastr.error(response.err);
        }
      });
  }

  getData() {
    this.loader.start()
    let localStorage = JSON.parse(this.storageService.getDataFromStorage('KUSA'))
    let data = {
      user_id: localStorage.user_id,
      id: this.parent_id,
      role: 'parent'
    }
    this.apiService
      .postMethod('/admin/get_user_data/', data)
      .subscribe((response: any) => {
        if (response.code == 200) {
          this.loader.stop()
          this.parent_data = response.data
          this.firstName = this.parent_data?.first_name
          this.lastName = this.parent_data?.last_name
          this.email = this.parent_data?.email ? this.parent_data?.email?.email_id : ""
          this.phone = this.parent_data?.phone ? this.parent_data.phone.phone_no : ' '
          this.parentName = this.parent_data?.parent_name ? this.parent_data.parent_name : ' '
          this.address = this.parent_data?.address ? this.parent_data?.address : ' '
          this.city = this.parent_data?.city ? this.parent_data?.city : ' '
          this.state = this.parent_data?.state ? this.parent_data?.state : ' '
          this.country = this.parent_data?.country ? this.parent_data?.country : ' '
          this.zipCode = this.parent_data?.zipCode ? this.parent_data?.zipCode : ' '
          this.school = this.parent_data?.school_name ? this.parent_data.school_name : ' '
          this.year = this.parent_data?.school_year ? this.parent_data.school_year : ' '
          this.selectGrade = this.parent_data?.grade_data[0]
          this.selectSubjects = this.parent_data?.subject_data
        } else {
          this.loader.stop();
          this.toastr.error(response.err);
        }
      });
  }
  downloadFile(format: any) {
    // debugger
    if (format == 'pdf') {

    } else if (format == 'excel') {
      if (!this.parent_data) {
        return this.toastr.error("No any data for download");
      }
      this.downloadExcelFile(this.parent_data)
    }

  }
  downloadExcelFile(e) {
    // debugger
    var exportdata: any = [];
    // resData.forEach((e: any) => {
    let data: any = {
      FirstName: e.first_name ? e.first_name : "",
      lastName: e.last_name ? e.last_name : "",
      Email: e.email ? e.email.email_id : "",
      Phone: e.phone ? e.phone.phone_no : "",
      ParentName: e.parent_name ? e.parent_name : "",
      Address: e.address ? e.address : "",
      City: e.city ? e.city : "",
      State: e.state ? e.state : "",
      Country: e.country ? e.country : "",
      ZipCode: e.zipCode ? e.zipCode : "",
      School: e.school_name ? e.school_name : "",
      Year: e.school_year ? e.school_year : "",
      Grade: e.grade_data[0].grade_level,
      // Subject: e.subject_data,
      // SessionDetails: e.request_session,
      // PackageDetails: e.package_details
    }
    let Subject = []
    for (let i = 0; i < e.subject_data.length; i++) {
      Subject.push(e.subject_data[i].subject_name)
    }
    data['Subject'] = Subject.toString();
    exportdata.push(data);

    e.package_details.forEach(details => {
      let packageDetails = {
        PackageName: details.packageId ? details.packageId.package_name : "",
        PackagePrice: details.session_price,
        Count: details.session_count,
      }
      exportdata.push(packageDetails);

    });
    e.request_session.forEach(element => {
      let session = {
        TutorName: element.tutor_id ? element.tutor_id.first_name : "",
        TutorEmail: element.tutor_id ? element.tutor_id.email.email_id : "",
        TutorPhone: element.tutor_id ? element.tutor_id.phone.phone_no : "",
        Subject: element.subject_id ? element.subject_id.subject_name : "",
        Grade: element.grade_id ? element.grade_id.grade_level : "",
        Slot: element.slot_time,
        Time: element.select_time,
        Date: element.select_date,
        Plateform: element.plateform,
      }
      exportdata.push(session);

    });

    // });
    this.download.DownloadInExcel("Parent Data", exportdata);
  }
  goBack() {
    this.router.navigate(['/parent']);
  }

  getGrades() {
    let data = {
      key: 1
    }
    this.apiService
      .postMethod('/user/get_grade_subjects/', data)
      .subscribe((response: any) => {
        if (response.code == 200) {
          this.loader.stop()
          this.grades = response.data
          console.log(this.grades);
        } else {
          this.loader.stop();
          this.toastr.error(response.err);
        }
      });
  }
  getSubjects() {
    let data = {
      key: 0
    }
    this.apiService
      .postMethod('/user/get_grade_subjects/', data)
      .subscribe((response: any) => {
        if (response.code == 200) {
          this.loader.stop()
          this.subjects = response.data
          // console.log(this.grades);
        } else {
          this.loader.stop();
          this.toastr.error(response.err);
        }
      });
  }
  changeLeagueOwner() {
    this.subjectData = []
    for (let i = 0; i < this.selectSubjects.length; i++) {
      let data = {
        subject_id: this.selectSubjects[i]._id
      }
      this.subjectData.push(data)
    }
    console.log(this.subjectData)
  }
}
